// extracted by mini-css-extract-plugin
export default {"heading":"Directions_heading__vig3v","ul":"Directions_ul__NZ6tc","li":"Directions_li__HyUeF"};